// extracted by mini-css-extract-plugin
export default {"button":"CustomStatuses_button__Rc4Fs","customStatus":"CustomStatuses_customStatus__WVhAk","input":"CustomStatuses_input__B7oR1"};